import { render, staticRenderFns } from "./commodityClassification.vue?vue&type=template&id=118a5e74&scoped=true&"
import script from "./commodityClassification.vue?vue&type=script&lang=js&"
export * from "./commodityClassification.vue?vue&type=script&lang=js&"
import style0 from "./commodityClassification.vue?vue&type=style&index=0&id=118a5e74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a5e74",
  null
  
)

export default component.exports